import { BOTTOMBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Grow, Paper } from '@mui/material';
import { X } from 'lucide-react';
import { ReactNode } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';

interface FloatingCardProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  title?: LangEnum;
  testId?: string;
}

const FloatingCard = ({ isOpen, onClose, children, title, testId }: FloatingCardProps) => {
  const { translate } = useTranslation();

  return (
    <Grow in={isOpen} unmountOnExit>
      <Paper
        variant="outlined"
        test-id={testId}
        sx={(theme) => ({
          position: 'fixed',
          bottom: `calc(${BOTTOMBAR.height}px + ${theme.spacing(1)})`,
          right: theme.spacing(2),
          zIndex: theme.zIndex.modal,
          maxWidth: `calc(100vw - ${theme.spacing(6)})`,
          borderRadius: `${theme.shape.borderRadius2xl}px`,
          boxShadow: theme.shadows[8],
          [theme.breakpoints.down('sm')]: {
            left: theme.spacing(2),
            right: theme.spacing(2),
            bottom: theme.spacing(2),
            maxWidth: 'none',
          },
        })}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {title && (
              <Typography variant="h6" component="h2" noWrap>
                {translate(title)}
              </Typography>
            )}
          </Box>
          {onClose && (
            <IconButton
              icon={X}
              size="medium"
              ariaLabel={translate(LangEnum.GLOBAL_CLOSE)}
              onClick={onClose}
              sx={{ color: 'action.active' }}
            />
          )}
        </Box>

        <Box sx={{ px: 2, pb: 2 }}>{children}</Box>
      </Paper>
    </Grow>
  );
};

export type { FloatingCardProps };
export default FloatingCard;
